import { setState } from './helpers'

const compareNewsFeedsByOrder = (first, second) => {
  const firstOrder = Number(first.order ?? 0)
  const secondOrder = Number(second.order ?? 0)

  if (firstOrder !== secondOrder) {
    return firstOrder - secondOrder
  }

  return Number(first.plainId ?? 0) - Number(second.plainId ?? 0)
}

const contentMutations = {
  SET_MESSAGES: setState('messages'),
  SET_MESSAGE: setState('message'),

  SET_THREADS: setState('threads'),
  SET_THREADS_USERS: setState('threadsUsers'),
  SET_THREADS_BY_SLUG(state, payload) {
    const ids = new Set(state.threadsBySlug.map((d) => d.id))

    state.threadsBySlug = [
      ...state.threadsBySlug,
      ...payload.data
        .map((item) => {
          return {
            ...item,
            slug: payload.slug
          }
        })
        .filter((d) => !ids.has(d.id))
    ]
  },

  SET_NEWS_FEEDS: setState('newsFeeds'),
  SET_NEWS_FEED: setState('newsFeed'),
  REORDER_NEWS_FEEDS(state, updates) {
    const orderMap = Object.fromEntries(
      updates.map((item) => [item.id, item.order]),
    )

    state.newsFeeds = [...state.newsFeeds]
      .map((item) =>
        orderMap[item.id] !== undefined
          ? { ...item, order: orderMap[item.id] }
          : item,
      )
      .sort(compareNewsFeedsByOrder)
  },
  UPDATE_NEWS_FEED_ORDER(state, { id, order }) {
    state.newsFeeds = [...state.newsFeeds]
      .map((item) => (item.id === id ? { ...item, order } : item))
      .sort(compareNewsFeedsByOrder)
  },

  SET_SURVEYS: setState('surveys'),
  SET_SURVEYS_ACTIVATED: setState('surveysActivated'),
  SET_SURVEY_GROUPS: setState('survey_groups')
}

export { contentMutations }
